import {Injectable} from '@angular/core'
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms'
import { QuestionBase } from '@app/models/question-base';

@Injectable()
export class QuestionControlService {
  toFormGroup(questions: QuestionBase<string>[]) {

    const group: any = {};

    questions.forEach((question) => {

      const validators : ValidatorFn[] = []

      if (question.required) validators.push(Validators.required)
      if (question.patternValidator) validators.push(Validators.pattern(new RegExp(question.patternValidator, 'i')))
      if (question.minLength) validators.push(Validators.minLength(question.minLength))
      if (question.maxLength) validators.push(Validators.maxLength(question.maxLength))

      group[question.key] = new FormControl(question.value || '', validators);
    });
    
    return new FormGroup(group);
  }
}